import { Field, FieldArray, ErrorMessage } from "formik";
import TextError from "../../../forms/TextError";
import { Plus, Trash2 } from "lucide-react";
import SelectMultipleWithSearch from "../../Admin/Common/SelectMultipleWithSearch";
import { memo, useCallback, useEffect, useRef, useState } from "react";
import { TimePicker } from "antd";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import SelectItem from "../Common/SelectItem";
import { NUMBER_OF_DAYS } from "../../../utils/constant";
dayjs.extend(customParseFormat);
const AddIteneraryForm = memo(({ formikData, airPort, type }) => {
  const { values } = formikData;
  const [addShow , setAddShow] = useState({
    arrivalOnAdd : false,
    arrivalOnChange : false
  })
  useEffect(()=>{
    if(addShow.arrivalOnAdd ){
    if(values.itinerary?.length > 1){
    addArrivalDate();
    }
    }
  },[addShow.arrivalOnAdd ])
  const addArrivalDate = useCallback(
    () => {
      let itinerary = [...values.itinerary];
        const lastIndex = itinerary.length - 1;
        const previousIndex = lastIndex - 1;
        const previousArrival = itinerary[previousIndex].arrival;
        itinerary[previousIndex].arrival = null;
        itinerary[lastIndex].arrival = previousArrival;
    },
    [addShow.arrivalOnAdd]
  );

  return (
    <>
      <div className="font-bold text-lg flex mt-4  mb-2 bg-gray-50 py-1 px-2 rounded-md ">
        <img
          src="https://staging.sgate.in/html/designer/skart/freight.png"
          className="w-[29px]"
        />

        <p className=" border-solid  border-l pl-3 ml-3">Flight Itinerary</p>
      </div>
      <div className="">
        <FieldArray name="itinerary">
          {({ remove, push , form }) => (
            <div>
              <div className="grid grid-cols-12 2xl:gap-3 xl:gap-3  lg:gap-3 gap-2">
              <div className="col-span-12 2xl:col-span-1 xl:col-span-1  lg:col-span-1  2xl:order-last xl:order-last  lg:order-last order-first">
                  {(type === "edit" || type === "create") && (
                    <div className=" float-right mt-[5px] 2xl:mt-[30px] xl:mt-[30px] xl:mt-[30px] originbuttonn">
                      <button
                        type="button"
                        onClick={() =>{
                          push({
                            origin: "",
                            destination: "",
                            departure: null,
                            arrival: null,
                            aircraft: "",
                            flight: "",
                            departureDay: 0,
                            arrivalDay: "",
                          })
                          setAddShow((prev)=>{
                            return {
                              ...prev ,
                              arrivalOnAdd : !prev.arrivalOnAdd
                            }
                          })
                          setTimeout(()=>{
                            setAddShow((prev)=>{
                              return {
                                ...prev ,
                                arrivalOnAdd : false,
                                arrivalOnChange : false
                              }
                            })
                          },0)
                         
                         
                        }}
                        title="Add New Item"
                        className="w-15 h-10 p-[5px] flex justify-center items-center"
                      >
                        <Plus className="text-white bg-yellow-500 hover:bg-gray-700 rounded-lg w-[35px] h-[35px] p-[1px] text-lg" />
                      </button>
                    </div>
                  )}
                </div>
                <div className="col-span-12 2xl:col-span-11 xl:col-span-11 lg:col-span-11">
                  {values?.itinerary?.map((itenary, index , itenerryArray) => (
                    <>
                      <div
                        key={index}
                        className="originplusMain my-3 justify-between  grid grid-cols-12   2xl:gap-2 xl:gap-2 lg:gap-2 gap-2"
                      >
                   
                        <div className="modalplusForm w-full 2xl:col-span-2 xl:col-span-2 lg:col-span-2  md:col-span-3  col-span-6">
                          <label
                            htmlFor={`itinerary.${index}.origin`}
                            className="py-0 block text-sm font-semibold leading-5 text-[#3F3F3F]"
                          >
                            Origin
                          </label>
                          {type === "edit" || type === "create" ? (
                            <>
                              <Field
                                as={SelectMultipleWithSearch}
                                options={airPort}
                                width={"100%"}
                                id={`itinerary.${index}.origin`}
                                name={`itinerary.${index}.origin`}
                                placeholder="Enter Units"
                                className="leading-6  px-2 py-2 focus:border focus:outline-0 block w-full text-sm font-normal border rounded-md text-[#757575]"
                                handleChange={formikData.handleChange}
                                setFieldValue={formikData.setFieldValue}
                              />

                              <ErrorMessage
                                name={`itinerary.${index}.origin`}
                                component={TextError}
                              />
                            </>
                          ) : (
                            <div className="p-2 border rounded-md text-sm text-[#757575] bg-gray-100">
                              {itenary?.origin
                                ?.split("-")?.[1]
                                ?.replace(/[()]/g, "")}
                            </div>
                          )}
                        </div>
                        <div className="modalplusForm w-full 2xl:col-span-2 xl:col-span-2 lg:col-span-2   md:col-span-3  col-span-6">
                          <label
                            htmlFor={`itinerary.${index}.destination`}
                            className="py-0 block text-sm font-semibold leading-5 text-[#3F3F3F]"
                          >
                            Destination
                          </label>
                          {type === "edit" || type === "create" ? (
                            <>
                              <Field
                                as={SelectMultipleWithSearch}
                                options={airPort}
                                width={"100%"}
                                id={`itinerary.${index}.destination`}
                                name={`itinerary.${index}.destination`}
                                placeholder="Enter Units"
                                className="leading-6  px-2 py-2 focus:border focus:outline-0 block w-full text-sm font-normal border rounded-md text-[#757575]"
                                handleChange={formikData.handleChange}
                                setFieldValue={formikData.setFieldValue}
                              />

                              <ErrorMessage
                                name={`itinerary.${index}.destination`}
                                component={TextError}
                              />
                            </>
                          ) : (
                            <div className="p-2 border rounded-md text-sm text-[#757575] bg-gray-100">
                              {itenary?.destination
                                ?.split("-")?.[1]
                                ?.replace(/[()]/g, "")}
                            </div>
                          )}
                        </div>

                        <div className="modalplusForm w-full 2xl:col-span-2 xl:col-span-2 lg:col-span-2   md:col-span-3  col-span-6">
                          <label
                            htmlFor={`itinerary.${index}.departureDay`}
                            className="py-0 block text-sm font-semibold leading-5 text-[#3F3F3F]"
                          >
                            Departure Days
                          </label>
                          {type === "edit" || type === "create" ? (
                            <>
                              <Field
                                as={SelectItem}
                                options={values.arrivalDays!="" ? NUMBER_OF_DAYS?.filter((item)=>item.value <= Number(values.arrivalDays) ) : NUMBER_OF_DAYS}
                                width={"100%"}
                                id={`itinerary.${index}.departureDay`}
                                name={`itinerary.${index}.departureDay`}
                                className="leading-4  px-1 py-1 focus:border focus:outline-0  w-[100%] text-sm font-normal border rounded-md text-[#757575]"
                                setFieldValue={formikData.setFieldValue}
                              />
                              <ErrorMessage
                                name={`itinerary.${index}.departureDay`}
                                component={TextError}
                              />
                            </>
                          ) : (
                            <div className="p-2 border rounded-md text-sm text-[#757575] bg-gray-100">
                              {itenary?.departureDay}
                            </div>
                          )}
                        </div>

                        <div className="modalplusForm w-full 2xl:col-span-2 xl:col-span-2 lg:col-span-2  md:col-span-3  col-span-6">
                          <label
                            htmlFor={`itinerary.${index}.departure`}
                            className="py-0 block text-sm font-semibold leading-5 text-[#3F3F3F]"
                          >
                            Departure
                          </label>
                          {type === "edit" || type === "create" ? (
                            <>
                              <Field
                                id={`itinerary.${index}.departure`}
                                name={`itinerary.${index}.departure`}
                              >
                                {({ field }) => (
                                  <TimePicker
                                    value={
                                      itenary?.departure != null
                                        ? dayjs(itenary?.departure, "HH:mm")
                                        : itenary?.departure
                                    }
                                    format="HH:mm"
                                    placeholder="Departure time"
                                    use12Hours={false}
                                    className="leading-6 px-2 py-2 focus:border focus:outline-0 block w-full text-sm font-normal border rounded-md text-[#757575]"
                                    onChange={(time, timeString) => {
                                      formikData.setFieldValue(
                                        `itinerary.${index}.departure`,
                                        time ? time.format("HH:mm") : ""
                                      );
                                     
                                    }}
                                  />
                                )}
                              </Field>

                              <ErrorMessage
                                name={`itinerary.${index}.departure`}
                                component={TextError}
                              />
                            </>
                          ) : (
                            <div className="p-2 border rounded-md text-sm text-[#757575] bg-gray-100">
                              {itenary?.departure}
                            </div>
                          )}
                        </div>
                        <div className="modalplusForm w-full 2xl:col-span-2 xl:col-span-2 lg:col-span-2   md:col-span-3  col-span-6">
                          <label
                            htmlFor={`itinerary.${index}.arrivalDay`}
                            className="py-0 block text-sm font-semibold leading-5 text-[#3F3F3F]"
                          >
                            Arrival Days
                          </label>
                          {type === "edit" || type === "create" ? (
                            <>
                              <Field
                                as={SelectItem}
                                options={values.arrivalDays!="" ? NUMBER_OF_DAYS?.filter((item)=>item.value <= Number(values.arrivalDays) ) : NUMBER_OF_DAYS}
                                width={"100%"}
                                id={`itinerary.${index}.arrivalDay`}
                                name={`itinerary.${index}.arrivalDay`}
                                className="leading-4  px-1 py-1 focus:border focus:outline-0  w-[100%] text-sm font-normal border rounded-md text-[#757575]"
                                setFieldValue={formikData.setFieldValue}
                              />
                              <ErrorMessage
                                name={`itinerary.${index}.arrivalDay`}
                                component={TextError}
                              />
                            </>
                          ) : (
                            <div className="p-2 border rounded-md text-sm text-[#757575] bg-gray-100">
                              {itenary?.arrivalDay}
                            </div>
                          )}
                        </div>
                        <div className="modalplusForm w-full 2xl:col-span-2 xl:col-span-2 lg:col-span-2   md:col-span-3   col-span-6">
                          <label
                            htmlFor={`itinerary.${index}.arrival`}
                            className="py-0 block text-sm font-semibold leading-5 text-[#3F3F3F]"
                          >
                            Arrival
                          </label>
                          {type === "edit" || type === "create" ? (
                            <>
                              <Field
                                id={`itinerary.${index}.arrival`}
                                name={`itinerary.${index}.arrival`}
                              >
                                {({ field }) => (
                                  <TimePicker
                                    value={
                                      itenary?.arrival != null
                                        ? dayjs(itenary?.arrival, "HH:mm")
                                        : itenary.arrival
                                    }
                                    format="HH:mm"
                                    placeholder="Arrival Time"
                                    use12Hours={false}
                                    // disabledTime={(selectedTime) => {
                                    //   const departureTime = itenary.departure
                                    //     ? dayjs(itenary.departure)
                                    //     : null;
                                    //   if (!departureTime) return {};

                                    //   return {
                                    //     disabledHours: () =>
                                    //       Array.from(
                                    //         { length: departureTime.hour() },
                                    //         (_, i) => i
                                    //       ),
                                    //     disabledMinutes: (hour) =>
                                    //       hour === departureTime.hour()
                                    //         ? Array.from(
                                    //             {
                                    //               length:
                                    //                 departureTime.minute(),
                                    //             },
                                    //             (_, i) => i
                                    //           )
                                    //         : [],
                                    //   };
                                    // }}
                                    className="leading-6 px-2 py-2 focus:border focus:outline-0 block w-full text-sm font-normal border rounded-md text-[#757575]"
                                    onChange={(time) => {
                                      formikData.setFieldValue(
                                        `itinerary.${index}.arrival`,
                                        time ? time.format("HH:mm") : ""
                                      );
                                     
                                      //  if(values?.itinerary?.length > 1 && values.itinerary.length-1 !=index){
                                      //   formikData.setFieldValue(
                                      //     `itinerary.${index+1}.departure`,
                                      //     time ? time.format("HH:mm") : ""
                                      //   );
                                      //  }
                                    }}
                                  />
                                )}
                              </Field>

                              <ErrorMessage
                                name={`itinerary.${index}.arrival`}
                                component={TextError}
                              />
                            </>
                          ) : (
                            <div className="p-2 border rounded-md text-sm text-[#757575] bg-gray-100">
                              {itenary?.arrival}
                            </div>
                          )}
                        </div>
                        <div className="modalplusForm w-full 2xl:col-span-2 xl:col-span-2 lg:col-span-2   md:col-span-3   col-span-6">
                          <label
                            htmlFor={`itinerary.${index}.aircraft`}
                            className="py-0 block text-sm font-semibold leading-5 text-[#3F3F3F]"
                          >
                            Aircraft
                          </label>
                          {type === "edit" || type === "create" ? (
                            <>
                              <Field
                                type="text"
                                id={`itinerary.${index}.aircraft`}
                                name={`itinerary.${index}.aircraft`}
                                className="leading-6  px-2 py-2 focus:border focus:outline-0 block w-full text-sm font-normal border rounded-md text-[#757575]"
                                onChange={formikData.handleChange}
                              />

                              <ErrorMessage
                                name={`itinerary.${index}.aircraft`}
                                component={TextError}
                              />
                            </>
                          ) : (
                            <div className="p-2 border rounded-md text-sm text-[#757575] bg-gray-100">
                              {itenary?.aircraft}
                            </div>
                          )}
                        </div>
                        <div className="modalplusForm w-full 2xl:col-span-2 xl:col-span-2 lg:col-span-2   md:col-span-3   col-span-6">
                          <label
                            htmlFor={`itinerary.${index}.flight`}
                            className="py-0 block text-sm font-semibold leading-5 text-[#3F3F3F]"
                          >
                            Flight
                          </label>
                          {type === "edit" || type === "create" ? (
                            <>
                              <Field
                                type="text"
                                id={`itinerary.${index}.flight`}
                                name={`itinerary.${index}.flight`}
                                className="leading-6  px-2 py-2 focus:border focus:outline-0 block w-full text-sm font-normal border rounded-md text-[#757575]"
                                onChange={formikData.handleChange}
                              />

                              <ErrorMessage
                                name={`itinerary.${index}.flight`}
                                component={TextError}
                              />
                            </>
                          ) : (
                            <div className="p-2 border rounded-md text-sm text-[#757575] bg-gray-100">
                              {itenary?.flight}
                            </div>
                          )}
                        </div>
                        {(type === "edit" || type === "create") && (
                          <div className="modalplusForm w-[100px] col-span-1 flex items-start mt-[20px]">
                            {index > 0 && (
                              <>
                                <button
                                  type="button"
                                  onClick={() => remove(index)}
                                  title="Delete Item"
                                  className="w-10 h-10 flex justify-center items-center"
                                >
                                  <Trash2 className="bg-red-200 hover:bg-yellow-500 hover:text-white  text-sm text-red-700 rounded-lg w-[40px] h-[36px] p-2 ml-[4px] mt-[-2px]" />
                                </button>
                              </>
                            )}
                          </div>
                        )}
                      </div>
                    </>
                  ))}
                </div>
              </div>
            </div>
          )}
        </FieldArray>
      </div>
    </>
  );
});

export default AddIteneraryForm;
